import {Grey17, Grey6} from "../../theme/styles";

import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {IconButton, Chip, Menu, MenuItem, Typography, Tooltip} from "@mui/material";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import css_self from "../Navigation/css/NavBar.module.scss";
import React from "react";
import EventBus from "../../util/EventBus";
import {Check, ControlPoint, DeleteForever, Info, MoreVert, Refresh} from "@mui/icons-material";
import ProjectPlanPhaseApprovalFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseApprovalFormApplet";
import {PlatformTable} from "../PlatformTable";

class ProjectPlanPhaseApprovalTable extends PlatformTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("project-plan-phase-approval-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("project-plan-phase-approval-form-applet-save", this.onCancelHandler);
    };

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("project-plan-phase-approval-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("project-plan-phase-approval-form-applet-save", this.onCancelHandler);
    };

    getCellRenderer(name) {
        if (name === "State Cell") {
            return this.renderStateCell;
        } else if (name === "Status Cell") {
            return this.renderStatusCell;
        } else if (name === "Action Cell") {
            return this.renderActionCell;
        }

        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "Add Phase Approver") {
            this.setState({renderTarget: "Add Phase Approver"});
        }
        super.handleMenuClick(identifier);
    }

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderExtension() {
        if (this.state.renderTarget === "Add Phase Approver") {
            return <ProjectPlanPhaseApprovalFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New"/>;
        }
        if (this.state.renderTarget === "Delete Phase Approver") {
            return <ProjectPlanPhaseApprovalFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete"/>;
        }
    };

    renderStateCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let backgroundColor;
        let content;
        if (this.state.buffer[params.row.id].get("DisplayStatus") === "Draft" || this.state.buffer[params.row.id].get("DisplayStatus") === "Last Signed" || this.state.buffer[params.row.id].get("DisplayStatus") === "WIP") {
            backgroundColor = "#DCF4FD";
            content = <Chip id="1" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #457AB5", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#457AB5", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else if (this.state.buffer[params.row.id].get("DisplayStatus") === "Pending Change" || this.state.buffer[params.row.id].get("DisplayStatus") === "Pending Approval" || this.state.buffer[params.row.id].get("DisplayStatus") === "In Review") {
            backgroundColor = "#FEF8EE";
            content = <Chip id="1" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #B25F00", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#B25F00", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else if (this.state.buffer[params.row.id].get("DisplayStatus") === "Released" || this.state.buffer[params.row.id].get("DisplayStatus") === "Approved") {
            backgroundColor = "#E6FCD9"
            content = <Chip id="2" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #509849", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#509849", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else {
            content = <Typography style={{marginTop: "10px"}}>{this.state.buffer[params.row.id].get("DisplayStatus")}</Typography>
        }
        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "100%"}}>
                {content}
            </div>
        );
    };

    deriveNewApprovalTooltip = () => {
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "IN REVIEW") {
            return "This feature is not available because the status of the phase is 'IN REVIEW'"
        }
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE") {
            return "This feature is not available because the status of the phase is 'DONE'"
        }
    }

    renderMenuContent() {
        let menuItems = [];

        menuItems.push(
            <MenuItem key={"menuItem1"} onClick={(e) => {
                if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== "DONE") {
                    e.stopPropagation();
                    this.handleMenuClick("Add Phase Approver");
                    this.setState({showMenu: false});
                }
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <ControlPoint sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Add Approver
                {this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE" ? (
                    <div style={{marginLeft: "10px", marginTop: "6px"}}>
                        <Tooltip title={this.deriveNewApprovalTooltip()}>
                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                        </Tooltip>
                    </div>
                ) : null}
            </MenuItem>
        );
        menuItems.push(
            <MenuItem key={"menuItem2"} onClick={(e) => {
                e.stopPropagation();
                this.handleMenuClick("Refresh");
                this.setState({showMenu: false});
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <Refresh sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Refresh
            </MenuItem>
        );

        return menuItems;
    };

    deriveApprovePhaseTooltip = () => {
        let sessionContext = this.props.appContext.sessionContext;

        if (this.applet.getEnterpriseComponent().getAttributeValue("AccountUserUSID") !== sessionContext.getAccountUserUSID()) {
            return `Only ${this.applet.getEnterpriseComponent().getAttributeValue("EmployeeUserName")} can approve this.`
        }
        if (this.applet.getEnterpriseComponent().getAttributeValue("Status") === "AWAITING APPROVAL") {
            return `The approval must be in the 'AWAITING APPROVAL' state.`
        }
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === null || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "IN PROGRESS") {
            return "The approver may only approve once the phase has been submitted for approval."
        }
    }

    deriveDeleteApproverTooltip = () => {
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== null || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== "IN PROGRESS") {
            return `An approver cannot be deleted once the phase is transitioned to 'IN REVIEW' or 'DONE'`;
        }
    }

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let sessionContext = this.props.appContext.sessionContext;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-10px"}}>
                <IconButton className={css_buttons.tableOptionButton} disableRipple sx={{"&:hover": {backgroundColor: "transparent"}}} onMouseDown={(event) => event.stopPropagation()} onClick={(event) => { event.stopPropagation();
                    this.applet.getEnterpriseComponent().selectRecord(params.row.id); this.setState({actionMenuAnchor: event.currentTarget, actionMenuRowId: params.row.id});
                }}>
                    <MoreVert sx={{fontSize: "1.35rem", position: "relative", top: "-1px"}} />
                </IconButton>
                <Menu
                    anchorEl={this.state.actionMenuAnchor}
                    anchorOrigin={{vertical: "center", horizontal: "right"}}
                    transformOrigin={{vertical: "top", horizontal: "left"}}
                    open={this.state.actionMenuRowId === params.row.id && !!this.state.actionMenuAnchor}
                    onClose={() => this.setState({actionMenuAnchor: null, actionMenuRowId: null})}
                    slotProps={{
                        paper: {elevation: 0, sx: {boxShadow: "none", borderRadius: 0, border: "1px solid #A8A9AF"}},
                        list: {...{"data-cc-component": "NavMenu"}, disablePadding: true, sx: {minWidth: "200px", "& .MuiMenuItem-root": {minHeight: "33px", height: "33px"}}},
                        transition: {onExited: () => this.setState({actionMenuAnchor: null, actionMenuRowId: null})},
                    }}
                >
                    <MenuItem divider key={"2"} className={css_self.Standard} onClick={() => {
                        if (this.applet.getEnterpriseComponent().getAttributeValue("AccountUserUSID") === sessionContext.getAccountUserUSID() && this.applet.getEnterpriseComponent().getAttributeValue("Status") === "AWAITING APPROVAL" && this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "IN REVIEW") {
                            this.applet.getEnterpriseComponent().selectRecord(params.row.id); this.setState({actionMenuAnchor: null, actionMenuRowId: null, renderTarget: "Approve"});
                        }
                    }}>
                        <Check style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Approve</Typography>
                        {(this.applet.getEnterpriseComponent().getAttributeValue("AccountUserUSID") !== sessionContext.getAccountUserUSID() || this.applet.getEnterpriseComponent().getAttributeValue("Status") !== "AWAITING APPROVAL" || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "IN REVIEW") ? (
                            <div style={{marginTop: "6px", marginLeft: "5px"}}>
                                <Tooltip title={this.deriveApprovePhaseTooltip()}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                    <MenuItem divider key={"3"} className={css_self.Standard} onClick={() => {
                        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== "DONE") {
                            this.applet.getEnterpriseComponent().selectRecord(params.row.id); this.setState({actionMenuAnchor: null, actionMenuRowId: null, renderTarget: "Delete Phase Approver"});
                        }
                    }}>
                        <DeleteForever style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Delete Approver</Typography>
                        {(this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE") ? (
                            <div style={{marginTop: "6px", marginLeft: "5px"}}>
                                <Tooltip title={this.deriveDeleteApproverTooltip()}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(ProjectPlanPhaseApprovalTable)));